import { render } from "./MaterialButton.vue?vue&type=template&id=15d609fb"
import script from "./MaterialButton.vue?vue&type=script&lang=js"
export * from "./MaterialButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__